<template>
  <popover :target="target" triggers="hover" custom-class="ancestors-popover" placement="top">
    <div class="popover-container">
      <team-item
        :team="team"
        :expanded-on-launch="true"
        :hide-caret="true"
        :next-route-name="ROUTE_NAMES.TEAM"
      ></team-item>
    </div>
  </popover>
</template>

<script>
import { ROUTE_NAMES } from '@/constants/routes'
import * as R from 'ramda'
import TeamItem from '@/components/team/TeamItem'
import { ENTITY_TYPE } from '@/constants/entities'
import Popover from '@/components/Popover'

/**
 * This shows ancestors of teamId upto root team
 */
export default {
  name: 'AncestorsPopover',
  props: ['target', 'teamId'],
  components: {
    Popover,
    TeamItem
  },
  data() {
    return {
      ENTITY_TYPE,
      team: this.getAncestors(this.teamId),
      ROUTE_NAMES
    }
  },
  computed: {},
  methods: {
    getAncestors(teamId) {
      let team = R.clone(this.$store.getters.teamById(teamId))
      team.children = []
      while (team.parentId) {
        const parent = R.clone(this.$store.getters.teamById(team.parentId))
        parent.children = [team]
        team = parent
      }
      return team
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/_styleConfigurations.scss';

.popover-container {
  min-width: 150px;
}
</style>
<style lang="scss">
.ancestors-popover .popover-body {
  padding: 12px 16px;
}
</style>
